import styles from "./AlertDetailCard.module.scss";
import { Card, CardContent, Chip } from "@material-ui/core";
import useWindowSize from "hooks/useWindowSize";
import { getAlarmType } from "shared/components/guard/Parser";
import Tooltip from "../Tooltip";
import i18n from "i18n";

const AlertDetailCard = ({ content, alert }) => {
  const { isMobile } = useWindowSize();

  const alertCommentClass = label =>
    label === i18n.t("comment") && alert.comments === i18n.t("no.comment")
      ? "without-comment"
      : "";

  return (
    <Card className={styles["alert-detail-card"]} component="article">
      <CardContent className={styles["alert-detail-card__content"]}>
        {isMobile && (
          <header className={styles["alert-detail-card__status-mobile"]}>
            <Chip label={getAlarmType(alert.status)} className={styles[alert.status]} />
          </header>
        )}

        {content.map(({ icon, label, value }) => (
          <div key={label}>
            <picture>
              <img src={icon} alt={label.toLowerCase()}/>
            </picture>
            <div>
              <p>{label}</p>
              {label === i18n.t("comment")  && value.length > 34 ? (
                <Tooltip content={<h3>{value}</h3>} text={value} />
              ) : (
                <h3 className={alertCommentClass(label) ? styles[alertCommentClass(label)] : undefined}>{value}</h3>
              )}
            </div>
          </div>
        ))}

        {!isMobile && (
          <footer className={styles["alert-detail-card__status-desk"]}>
            <Chip label={getAlarmType(alert.status)} className={styles[alert.status]} />
          </footer>
        )}
      </CardContent>
    </Card>
  );
};

export default AlertDetailCard;
